import { useNavigate } from 'react-router-dom';
import { ModalBody } from 'reactstrap';

import lang from '../../lib/language';

import BaseModal from '../../shared_components/BaseModal/BaseModal';
import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';

import styles from './NotEnoughBuyingPower.module.scss';

type Props = {
  closeModal: () => void;
};

const NotEnoughBuyingPower = ({ closeModal }: Props) => {
  const navigate = useNavigate();

  return (
    <BaseModal isOpen>
      <h6 className={styles.header}>{lang.commonTradingNotEnoughBuyingPowerTitle()}</h6>
      <ModalBody>
        <p className={styles.text}>{lang.commonTradingNotEnoughBuyingPowerDescription()}</p>
        <div className={styles.actions}>
          <Button
            variant={ButtonTypesEnum.Primary}
            fullWidth
            className={styles.btnCancel}
            onClick={() => closeModal()}
          >
            {lang.commonGood() }
          </Button>
        </div>
      </ModalBody>
    </BaseModal>
  );
};

export default NotEnoughBuyingPower;
